export default [
    {
        path: '/callworktask/list',
        meta: {
           // authCode: "xcrm.callcustomer.list"
        },
        component: (resolve) => require(['./CallWorkTaskList.vue'], resolve),
    }
]



// WEBPACK FOOTER //
// ./src/modules/callWorkTask/router.js